import { useMemo } from "react";
import { selectors, useAppSelector } from "store";
export var useCupFamilyOptions = function () {
    var systemDataDefineParameters = useAppSelector(selectors.selectSystemDataDefineParameters);
    var suctionCups = systemDataDefineParameters === null || systemDataDefineParameters === void 0 ? void 0 : systemDataDefineParameters.suctionCupComponents;
    var cupFamilyOptions = useMemo(function () {
        if (!suctionCups)
            return [];
        var cupFamilyOptionsList = Object.values(suctionCups)
            .filter(function (component) { return component.valid; })
            .map(function (item) { return item.cupFamily; })
            .filter(function (item, index, self) { return self.indexOf(item) === index; });
        return cupFamilyOptionsList;
    }, [suctionCups]);
    var cupFamilyDropdownImages = useMemo(function () {
        if (!suctionCups)
            return [];
        var cupFamilies = cupFamilyOptions.map(function (family) {
            return Object.values(suctionCups !== null && suctionCups !== void 0 ? suctionCups : {}).find(function (component) { return component.image && component.cupFamily === family; });
        });
        var cupFamilyImages = cupFamilies.map(function (family) { return family === null || family === void 0 ? void 0 : family.image; });
        return cupFamilyImages;
    }, [cupFamilyOptions, suctionCups]);
    return { cupFamilyOptions: cupFamilyOptions, cupFamilyDropdownImages: cupFamilyDropdownImages };
};
